export const friendsState = {
    loading: true,
    friends: [],
    error: null
  };
  
  export const friendsReducer = (state, action) => {
    switch (action.type) {
      case "FETCH_FRIENDS": {
        return {
          loading: true,
          friends: [],
          error: null
        };
      }
      case "FRIENDS_LOADED": {
        return {
          loading: false,
          friends: action.payload,
          error: null
        };
      }
      case "FRIENDS_ERROR": {
        return {
          loading: false,
          friends: [],
          error: true
        };
      }
  
      default:
        throw new Error("Не тот экшен");
    }
  };
  